import { useConfiguracionStore } from "../hooks/useConfiguracionesStore";
import { useDepositosStore } from "../hooks/useDepositosStore";
import { useStockControlStore } from "../hooks/useStockControlStore";
import { useLoading } from "../hooks/useLoading";
import inventario from "../api/inventario";

export const useControlStockVoluntario = () => {
  const { configuracion } = useConfiguracionStore();
  const { depositoSeleccionado } = useDepositosStore();
  const { setArticulo, setStockTeorico, setMsgError, setStockReal } = useStockControlStore();
  const { loading, withLoading } = useLoading();

  const buscarArticuloYVerificarAjuste = async (codigoBarra, fecha) => {
    try {
      //  Limpiar stock real antes de cargar un nuevo artículo
      setStockReal(null);

      const buscarEnSinonimos = configuracion?.buscarEnSinonimos ? 1 : 0;
      const buscarEnCodigo = configuracion?.buscarEnCodigo ? 1 : 0;

      const articulo = await withLoading(async () => {
        return await inventario.getArticuloIMAPorCodigoDeBarras({
          codBarra: codigoBarra,
          buscarEnSinonimos,
          buscarEnCodigo,
        });
      });

      if (!articulo || articulo.msgError) {
        setMsgError(`No se encontró un artículo con el código de barras '${codigoBarra}'`);
        return;
      }

      setArticulo(articulo);

      const responseStockTeorico = await withLoading(async () => {
        return await inventario.getStockTeoricoIMA(articulo.idArticulo, depositoSeleccionado?.idDeposito || 0, fecha);
      });
      setStockTeorico(responseStockTeorico.stockTeorico);

      const movimientos = await withLoading(async () => {
        return await inventario.getMovimientoStock(articulo.idArticulo, depositoSeleccionado?.idDeposito || 0);
      });

      let tieneAjuste = false;

      if (Array.isArray(movimientos)) {
        tieneAjuste = movimientos.some(m => m.idTipoMovimiento === "AJI");
      } else {
        tieneAjuste = movimientos.idTipoMovimiento === "AJI";
      }

      if (!tieneAjuste) {
        setMsgError(" Este artículo aún no fue ajustado por inventario (AJI) en este depósito.");
      } else {
        setMsgError(""); // Limpia  si ya tiene ajuste
      }
    } catch (err) {
      console.error("Error al buscar artículo y verificar ajuste:", err);
      setMsgError("Ocurrió un error al buscar el artículo.");
    }
  };

  return { buscarArticuloYVerificarAjuste, loading };
};
